import React, { Component } from 'react';
//import DEV_RAINBOW_LOGO from "assets/qr_code/dev-rainbow.png";
//import DEV_RAINBOW_BG from "assets/qr_code/dev-rainbow-bg.png";
//import { createUseStyles } from "react-jss";

const ICON_SIZE = 100;

// const useStyles = createUseStyles(theme => ({
// //   root: {
// //     backgroundImage: `url('${DEV_RAINBOW_BG}')`,
// //     maxWidth: 1060,
// //     maxHeight: 1521,
// //     borderRadius: "32px",
// //     border: "5px solid #EFEFF7",
// //     padding: theme.spacing(11),
// //   },
// //   logo: {
// //     boxShadow: "9px 3px 20px 1px rgb(0 0 0 / 10%)",
// //     height: 150,
// //     width: 150,
// //     borderRadius: 8,
// //   },
// //   icon: {
// //     borderRadius: 8,
// //     width: ICON_SIZE,
// //     height: ICON_SIZE,
// //     position: "absolute",
// //     top: `calc(50% - ${ICON_SIZE / 2 + 1}px)`,
// //     left: `calc(50% - ${ICON_SIZE / 2 - 5}px)`,
// //   },
// //   qrContainer: {
// //     position: "relative",
// //     backgroundColor: "#EFEFF7",
// //     borderRadius: "56px",
// //     margin: theme.spacing(8, 0),
// //     padding: theme.spacing(4),
// //   },
// //   qrInner: {
// //     backgroundColor: "white",
// //     borderRadius: "32px",
// //     padding: 90,
// //   },
// //   referredBy: {
// //     fontStyle: "normal",
// //     fontWeight: "600",
// //     fontSize: "24px",
// //     lineHeight: "29px",
// //     letterSpacing: "0.1em",
// //   },
// }));

//export default function QRCodeTemplate({ children }) {
export class QRCodeTemplate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            children: props.children
        }
    }
    //const classes = useStyles();
    render() {
        return (
            <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div id={this.state.children.props.id}>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div>{this.state.children}</div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 qrCodeCustom">
                            <h2>
                                <b>{this.state.children.props.id}</b>
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}